import { HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NavmenuComponent } from './navmenu/navmenu.component';
import {NgxPhotoEditorModule} from "ngx-photo-editor";
import { UserService } from '../app/shared/services/user.service';
import { CommonapiService } from '../app/shared/services/commonapi.service';
import { CountUpModule } from 'ngx-countup';
import { HomeComponent } from './home/home.component';
import { SafetyprogramComponent } from './safetyprogram/safetyprogram.component';
import { FooterComponent } from './footer/footer.component';
import { SafetytrainingComponent } from './safetytraining/safetytraining.component';
import { SafetyinspectionsComponent } from './safetyinspections/safetyinspections.component';
import { TermsComponent } from './terms/terms.component';
import { OurcompanyComponent } from './ourcompany/ourcompany.component';
import { OurteamComponent } from './ourteam/ourteam.component';
import { ContactComponent } from './contact/contact.component';
import { BlogComponent } from './blog/blog.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { OurteamdetailComponent } from './ourteamdetail/ourteamdetail.component';
import { BlogdetailComponent } from './blogdetail/blogdetail.component';
import { ColoradoComponent } from './colorado/colorado.component';
import { TexasComponent } from './texas/texas.component';
import { ArizonaComponent } from './arizona/arizona.component';
import { OshaprocedureComponent } from './oshaprocedure/oshaprocedure.component';
import { DmsComponent } from './dms/dms.component';
import { BlogquestionComponent } from './blogquestion/blogquestion.component';
import { FaqComponent } from './faq/faq.component';
import { SafetyvideosComponent } from './safetyvideos/safetyvideos.component';
import { NewsletterComponent } from './newsletter/newsletter.component';
import { OthertrainingsComponent } from './othertrainings/othertrainings.component';
import { NsprogramComponent } from './nsprogram/nsprogram.component';
import { RsprogramComponent } from './rsprogram/rsprogram.component';
import { DmsfaqComponent } from './dmsfaq/dmsfaq.component';
import { NotfoundComponent } from './notfound/notfound.component';
import { OshaComponent } from './osha/osha.component';
import {NoSanitizePipe} from './shared/pipes/htmlpipe';
import { OnsitetrainingComponent } from './onsitetraining/onsitetraining.component';
import { FloridaComponent } from './florida/florida.component';
import { LivetrainingsComponent } from './livetrainings/livetrainings.component';
import { TrainingloginComponent } from './traininglogin/traininglogin.component';
import { TrainingentryComponent } from './trainingentry/trainingentry.component';
import {SignaturePadModule } from 'angular2-signaturepad';
import { CareersComponent } from './careers/careers.component';
import { MeetingloginComponent } from './meetinglogin/meetinglogin.component';
import { MeetingentryComponent } from './meetingentry/meetingentry.component';
import { HelpfileComponent } from './helpfile/helpfile.component';
import { SfiteamComponent } from './sfiteam/sfiteam.component';
import { NorthcarolinaComponent } from './northcarolina/northcarolina.component';
import { WebcamModule } from 'ngx-webcam';
// import function to register Swiper custom elements
import { register } from 'swiper/element/bundle';
import { PrivacyComponent } from './privacy/privacy.component';
import { EulaComponent } from './eula/eula.component';
// register Swiper custom elements
register();

@NgModule({
  declarations: [
    AppComponent,    
    NavmenuComponent,
    HomeComponent,
    SafetyprogramComponent,
    FooterComponent,
    SafetytrainingComponent,
    SafetyinspectionsComponent,
    TermsComponent,
    OurcompanyComponent,
    OurteamComponent,
    ContactComponent,
    BlogComponent,
    OurteamdetailComponent,
    BlogdetailComponent,
    ColoradoComponent,
    TexasComponent,
    ArizonaComponent,
    OshaprocedureComponent,    
    DmsComponent,
    BlogquestionComponent,
    FaqComponent,
    SafetyvideosComponent,
    NewsletterComponent,
    OthertrainingsComponent,
    NsprogramComponent,
    RsprogramComponent,
    DmsfaqComponent,    
    NotfoundComponent, 
    OshaComponent,
    NoSanitizePipe,
    OnsitetrainingComponent,
    FloridaComponent,
    LivetrainingsComponent,
    TrainingloginComponent,
    TrainingentryComponent,
    CareersComponent,
    MeetingloginComponent,
    MeetingentryComponent,
    HelpfileComponent,
    SfiteamComponent,
    NorthcarolinaComponent,
    PrivacyComponent,
    EulaComponent
  ],
  imports: [
    BrowserModule,    
    AppRoutingModule,
    HttpClientModule,
    CountUpModule,
    NgxSkeletonLoaderModule,        
    FormsModule,    
    SignaturePadModule,
    NgxPhotoEditorModule,
    WebcamModule
  ],
  providers: [
    UserService,
    CommonapiService
  ],
  bootstrap: [AppComponent],
  schemas:[CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
